// extracted by mini-css-extract-plugin
module.exports = {"infoSection":"offer-card_infoSection__CJafr","title":"offer-card_title__y3_kF","extraInfo":"offer-card_extraInfo__QqjRy"};